import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { useApp } from "../../contexts/AppContext";
import ContactModal from "../Auth/ContactModal";
import { siteConfig } from "../../config/siteConfig";

const Layout = ({ children, setShowProfile }) => {
  const { view, setView, isPremium } = useApp();
  const [isContactOpen, setIsContactOpen] = useState(false);
  const isExamMode = view === "exam";
  const showBanner = !isPremium && view !== "billing" && !isExamMode;
  const { uiCopy, brand } = siteConfig;

  return (
    <div className="flex h-screen overflow-hidden bg-[#f8fafc]">
      {!isExamMode && (
        <div className="hidden lg:block">
          <Sidebar />
        </div>
      )}

      <main className="flex-grow flex flex-col h-screen overflow-hidden relative">
        {showBanner && (
          <div className="bg-gradient-to-r from-rose-700 via-red-600 to-orange-500 text-white py-3 px-4 text-center z-[100] flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 shadow-md shrink-0">
            <span className="text-[10px] md:text-xs font-bold uppercase tracking-wider leading-tight">
              {uiCopy.bannerCta}
            </span>
            <button onClick={() => setView("billing")} className="bg-white text-red-600 px-4 py-1 rounded-full text-[10px] font-black uppercase">
              {uiCopy.bannerCtaButton}
            </button>
          </div>
        )}
        {!isExamMode && <Header setShowProfile={setShowProfile} onOpenContact={() => setIsContactOpen(true)} />}

        <div id="main-scroll" className={`flex-grow overflow-y-auto custom-scrollbar ${isExamMode ? "p-0" : "p-4 md:p-8"}`}>
          <div className={isExamMode ? "w-full h-full" : "max-w-7xl mx-auto min-h-[calc(100vh-180px)] flex flex-col"}>
            <div className="flex-grow">{children}</div>
            {!isExamMode && (
              <footer className="mt-8 py-4 text-center text-slate-400 text-xs border-t border-slate-200">
                <p>
                  &copy; {new Date().getFullYear()} {brand.name}. Todos los derechos reservados.
                </p>
              </footer>
            )}
          </div>
        </div>
      </main>
      <ContactModal isOpen={isContactOpen} onClose={() => setIsContactOpen(false)} />
    </div>
  );
};

export default Layout;
